import { getInheritableTypeAsEdited } from './utils';


export type InheritableType = 'empty'|'set'|'inherited'|'overridden'|'inherited-overridden';
export type UserDefinedInheritableType = 'set'|'overridden';


export abstract class IsInheritable {
  inheritableType: InheritableType;

  getClonedInheritableTypeAsChild(): InheritableType {
    switch (this.inheritableType) {
      case 'set':
        return 'inherited';
      case 'overridden':
        return 'inherited-overridden';
    }
    return this.inheritableType;
  }

  // TODO: the argument should be UserDefinedInheritableType
  getUserDefinedInheritableTypeAsChild(inheritableType: InheritableType): InheritableType {
    switch (this.inheritableType) {
      case 'empty':
        switch (inheritableType) {
          case 'overridden':
            return 'set';
        }
        break;
      case 'set':
      case 'inherited':
      case 'overridden':
      case 'inherited-overridden':
        switch (inheritableType) {
          case 'set':
            return 'overridden';
        }
        break;
    }

    return inheritableType;
  }

  getInheritableTypeAsEdited(): InheritableType {
    return getInheritableTypeAsEdited(this.inheritableType);
  }

  isDeletable(): boolean {
    return this.inheritableType === 'set' || this.inheritableType === 'overridden';
  }
}
